import React from 'react';
import { Search, Filter } from 'lucide-react';

export default function StatusFilterPanel({ filters, onFiltersChange, stats }) {
  return (
    <div className="bg-white rounded-lg shadow p-4 mb-6">
      <div className="flex items-center space-x-2 mb-4">
        <Filter className="text-gray-600" size={20} />
        <h3 className="text-lg font-semibold text-gray-900">Filtres</h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Search */}
        <div className="lg:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-1">Recherche</label>
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
            <input
              type="text"
              placeholder="Nom, téléphone, email..."
              value={filters?.searchQuery}
              onChange={(e) => onFiltersChange({ ...filters, searchQuery: e?.target?.value })}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
            />
          </div>
        </div>

        {/* Status Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Statut</label>
          <select
            value={filters?.status || 'all'}
            onChange={(e) => onFiltersChange({ ...filters, status: e?.target?.value === 'all' ? null : e?.target?.value })}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
          >
            <option value="all">Tous ({stats?.totalReservations || 0})</option>
            <option value="pending">En Attente ({stats?.pendingCount || 0})</option>
            <option value="confirmed">Confirmées ({stats?.confirmedCount || 0})</option>
            <option value="processing">En Traitement ({stats?.processingCount || 0})</option>
            <option value="completed">Terminées ({stats?.completedCount || 0})</option>
            <option value="cancelled">Annulées ({stats?.cancelledCount || 0})</option>
          </select>
        </div>

        {/* Confirmation Sent Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Confirmation</label>
          <select
            value={filters?.confirmationSent === null ? 'all' : filters?.confirmationSent ? 'sent' : 'not_sent'}
            onChange={(e) => {
              const value = e?.target?.value === 'all' ? null : e?.target?.value === 'sent';
              onFiltersChange({ ...filters, confirmationSent: value });
            }}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
          >
            <option value="all">Toutes</option>
            <option value="sent">Envoyées</option>
            <option value="not_sent">Non envoyées</option>
          </select>
        </div>
      </div>

      {/* Date Range */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Date de début</label>
          <input
            type="date"
            value={filters?.startDate || ''}
            onChange={(e) => onFiltersChange({ ...filters, startDate: e?.target?.value })}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Date de fin</label>
          <input
            type="date"
            value={filters?.endDate || ''}
            onChange={(e) => onFiltersChange({ ...filters, endDate: e?.target?.value })}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
          />
        </div>
      </div>

      {/* Clear Filters */}
      {(filters?.searchQuery || filters?.status || filters?.startDate || filters?.endDate || filters?.confirmationSent !== null) && (
        <div className="mt-4">
          <button
            onClick={() => onFiltersChange({ status: null, searchQuery: '', startDate: null, endDate: null, confirmationSent: null })}
            className="text-sm text-red-600 hover:text-red-700 font-medium"
          >
            Réinitialiser les filtres
          </button>
        </div>
      )}
    </div>
  );
}